import IMSUrlService from '@/services/imsUrlService'

/**
 * Composable for IMS Image Provider functionality.
 * Provides methods to get image URLs with proper parameters based on the configured provider.
 */
export const useImsImageProvider = () => {
  /**
   * Get the base URL for the configured IMS provider.
   */
  const getBaseUrl = (): string => {
    return IMSUrlService.getBaseUrl()
  }

  /**
   * Get image parameters for optimization based on the configured provider.
   *
   * @param options - Image optimization options
   * @returns Query parameters string for image optimization
   */
  const getImageParams = (options?: {
    width?: number
    height?: number
    quality?: number
    fit?: string
    auto?: string
  }): string => {
    return IMSUrlService.getImageParams(options || {})
  }

  /**
   * Build a complete image URL with the base URL and optimization parameters.
   *
   * @param imagePath - The path to the image (without base URL)
   * @param options - Image optimization options
   * @returns Complete image URL with optimization parameters
   */
  const buildImageUrl = (
    imagePath: string,
    options?: {
      width?: number
      height?: number
      quality?: number
      fit?: string
      auto?: string
    }
  ): string => {
    const params = getImageParams(options)

    if (!imagePath) {
      return params
    }
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath
    return `${cleanPath}${params}`
  }

  return {
    getBaseUrl,
    getImageParams,
    buildImageUrl
  }
}
